import { useTranslation } from 'react-i18next';

/** What a staff-but-not-admin user sees at /admin until a staff feature exists. */
const StaffLanding = () => {
  const { t } = useTranslation();
  return (
    <div className="container mt-5">
      <div className="notification is-info is-light">
        <h1 className="title is-4">{t('admin.staff_landing.title')}</h1>
        <p>{t('admin.staff_landing.message')}</p>
      </div>
    </div>
  );
};

export default StaffLanding;
